import React, { useState } from "react"
import { Box, Typography } from "@mui/material"
import { AppToggleButton } from "@components"
import { autoEuropeDrawerData } from "Pages/AutoEuropeTool/Page/@signals"
import { dsColorNew } from "@palette"

export default function AutoEuropeCompareBy() {
	const initial = autoEuropeDrawerData.peek().compareByCategory ?? false
	const [selected, setSelected] = useState(initial ? 'category' : 'acriss')

	const handleChange = (_, newVal) => {
		if (newVal === null) return
		setSelected(newVal)
		autoEuropeDrawerData.value = {
			...autoEuropeDrawerData.value,
			compareByCategory: newVal === 'category',
			filterAcriss: [],
			filterAcrissExclusion: false,
			filterCategories: [],
			filterCategoriesExclusion: false,
		}
	}

	return (
		<Box>
			<Typography sx={{ mb: 1, fontSize: 14, fontWeight: 500, color: dsColorNew.textDark }}>Compare By</Typography>
			<AppToggleButton
				value={selected}
				onChange={handleChange}
				tabs={[{ value: 'acriss', label: 'ACRISS' }, { value: 'category', label: 'Category' }]}
			/>
		</Box>
	)
}